import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './AdmitCard.css';
import LG_Cont from "../../../router/containers/Lg_Cont";
const AdmitCard = (props) => {


  const downloadAdmitCard = () => {
    const input = document.getElementById('admit-card');
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      imageTimeout: 15000,
      logging: false
    })
      .then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgProps = pdf.getImageProperties(imgData);

        // Scale the captured card to fit entirely on ONE A4 page
        // (contain-fit: shrink width or height as needed, keep aspect ratio)
        let imgWidth = pdfWidth;
        let imgHeight = (imgProps.height * imgWidth) / imgProps.width;

        if (imgHeight > pdfHeight) {
          imgHeight = pdfHeight;
          imgWidth = (imgProps.width * imgHeight) / imgProps.height;
        }

        const x = (pdfWidth - imgWidth) / 2;
        const y = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
        pdf.save("admit_card.pdf");
      })
      .catch(err => {
        console.error('Failed to generate admit card PDF:', err);
      });
  };
  const handlePrint = () => {
    window.print();
  };
  console.log(props.login)
  return (
    <div>
      {props.login.admitcard_details === null ?
        <div>
          <center>
         
       <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", color: "#333" }}>
      <p>
        Since your admit card could not be issued due to incomplete data, you are required
        to collect it from the examination center on the day of the test. Please ensure you
        carry a valid Aadhar card or any other government-issued identification document
        along with a recent passport-size photograph to any one of the four designated centers.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "20px" }}>The centers are as follows:</p>

      <ul style={{ lineHeight: "1.8", fontSize: "16px", paddingLeft: "20px" }}>
        <li>
          <strong>1. Angul Center</strong><br />
          <em>Saraswati Shishu Mandir, Angul</em><br />
          Address: Saraswati Sishu Vidya Mandir, Bikrampur, Angul, Odisha – 759122
        </li>
        <li>
          <strong>2. Balasore Center</strong><br />
          <em>Bhabani School Campus</em><br />
          Address: Bhabani School Campus,
Near Shergarh tollgate, Balasore.
        </li>
        <li>
          <strong>3. Bhubaneswar Center</strong><br />
          <em>Prabhujee English Medium School, Bhubaneswar</em><br />
          Address: Prabhujee English Medium School, Near Indian Overseas Bank, V.S.S. Nagar,
          Bhubaneswar, Odisha – 751007
        </li>
        <li>
          <strong>4. Jajpur Center</strong><br />
          <em>  Prayash Vidyamandir,</em><br />
        Address : Tandara, Badabiruan, Near Sankhachila Police station, Jajpur, 755015

        </li>
      </ul>

      <p style={{ fontWeight: "bold", marginTop: "20px" }}>
        Please report to the center by 9:30 AM. The examination will begin at 11:00 AM.
      </p>
    </div>
 
           
           
          </center>
        </div>
        :
        <div>

          <div className="container" id="admit-card">
            <div className="header">


              <img src="logo.png" alt="Logo" crossOrigin="anonymous" />
              <h1 style={{ fontSize: "20px", color: "#18537a", textTransform: "uppercase", fontWeight: 900 }}>Prayash Clasess </h1>
            </div>
            <h2 style={{ border: "1PX SOLID BLACK", textAlign: "center", padding: "10px", fontSize: "25px", textTransform: "uppercase" ,fontWeight: 900 }}>NEET 2027 ADMISSION TEST<br></br> <b style={{
              backgroundColor: "#18537a", color: "#fff", borderRadius: 30, padding: "10px", fontSize: "15px", fontWeight: "bold"

            }}>  ADMIT CARD</b></h2>

            <div style={{ padding: "0px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
              <div style={{ width: "70%" }}>
                <table className="info">
                  <tbody>
                    <tr>
                      <th> Roll no</th>
                      <td>

                   {props.login.admitcard_details.rollno}
                      </td>

                    </tr>
                    <tr>
                      <th>Name</th>
                      <td>{props.login.user_details.name}</td>
                    </tr>
                    <tr>
                      <th>Father’s name</th>
                      <td>{props.login.user_details.fname}</td>
                    </tr>
                    <tr>
                      <th>Aadhaar no.</th>
                      <td>{props.login.user_details.aadhar}</td>
                    </tr>


                  </tbody>
                </table>
              </div>
              <div style={{ border: "1px solid black", width: "28%", display: "flex", flexDirection: "column", justifyContent: "space-around" }}>

                <div>{props.login.user_details.profile_pic === null ? <p>PASTE YOUR RECENT COLOUR PASSPORT SIZE PHOTO</p> : <img style={{ height: "150px", width: "170px", textAlign: "center", fontSize: "10px", padding: "15px" }} alt='PASTE YOUR RECENT COLOUR PASSPORT SIZE PHOTO' src={props.login.user_details.profile_pic} crossOrigin="anonymous"></img>}</div>

                <div>

                  <p style={{ fontSize: "10px", marginTop: "20px", textAlign: "center" }} >Full Signature Of the Candidate</p>
                </div>
              </div>

            </div>

            <br>
            </br>
            <div style={{ border: "1px solid black", padding: "10px", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
              <div>
                <p>
                  CODE
                </p>
                <p>
                  Date of examination:
                </p>
                <p>
                  Reporting/entry time at center:
                </p>
                <p>

                  Gate closing time of center:
                </p>
                <p>
                  Timing of test:
                </p>
                <p>

                  Test center name:
                </p>
                <p>

                </p>
                Test center address:


              </div>
              <div>
                <p>
                  :
                </p>
                <p>
                  :
                </p>
                <p>
                  :
                </p>
                <p>

                  :
                </p>
                <p>
                  :
                </p>
                <p>

                  :
                </p>
                <p>

                </p>
                :


              </div>
              <div>
                <p>
                  {props.login.admitcard_details.code}2027 
                </p>
                <p>
                  5th July, 2026, Sunday
                </p>
                <p>
                  09.30 AM
                </p>
                <p>

                  10.30 AM
                </p>
                <p>
                  11.00 AM - 02.00 PM
                </p>
                <p>
  {props.login.admitcard_details.examcenter}
                 

                </p>
                <p style={{ width: "300px" }}>
  {props.login.admitcard_details.centeradd}

                  
                </p>

              </div>




            </div>

            <div className="instructions">
              <h3>IMPORTANT INSTRUCTIONS FOR CANDIDATES</h3>
              <ul>
                <li>Candidates must reach the examination centre as per the reporting time mentioned on the Admit Card..</li>
                <li>No candidate shall be permitted to enter the Centre after the Gate Closing- Time.
</li>
                {/* <li>No candidate shall be permitted to leave the Examination Room/Hall before the end of the examination.</li> */}
                <li>No candidate will be allowed to enter the examination centre without presenting any one of the following documents in original along with the Admit Card, Aadhar Card, or any other photo identification.
                </li>
                <li>On completion of the examination, please wait for instructions from Invigilator and do not get up from your seat until advised. The candidates will be permitted to move out one at a time only.
</li>
                {/* <li>⁠No candidate will be permitted to enter the examination center without presenting any one of the following in original: Last School ID Card, Aadhar Card, or any other photo identification.</li> */}
                <li>Candidates are allowed to carry only the following items with them into the examination venue:
                  <ul>
                    <li>(a)Personal transparent water bottle.</li>
                    <li>(b) Blue/Black ball point pen</li>
                  </ul>
                </li>
                <li>Candidates are advised to adhere to the formal dress code.              </li>
                <li>No candidate shall be permitted to leave the Examination Room/Hall before the end of the examination.

                </li>
                <li>On completion of the examination, candidates must wait for instructions from the invigilator and remain seated until advised. Candidates will be permitted to leave one at a time only.

                </li>
                <li>Candidates are NOT allowed to carry any personal belongings including electronic devices, mobile phones and other banned / prohibited items to the Examination Centre. </li>
                <li>Examination Officials will not be responsible for the safe keep of personal belongings and there will be no facility.
 </li>
                <li>On completion of the test, candidates must hand over the OMR Sheet and the Test Booklet to the Invigilator.
                </li>
                {/* <li>Candidate must carry Aadhar Card  and  Admit card as identity proof.</li> */}
                {/* <li>Candidates are NOT allowed to carry any personal belongings including electronic devices, mobile phones and other banned / prohibited items listed in the Information Bulletin to the Examination Centre. Examination Officials will not be responsible for the safe keep of personal belongings and there will be no facility.</li> */}
                {/* <li>⁠Candidates are advised to adhere to the formal dress code or wear their last school uniform.</li> */}
                {/* <li>No Candidate should adopt any unfair means or indulge in any unfair examination practices as the examination Centers are under surveillance of CCTV and equipped with Jammers.</li> */}
                {/* <li>On completion of the test, candidates must hand over the OMR Sheet to the Invigilator and the Test Booklet.</li> */}
              </ul>
            </div>
          </div>   <center>

            <button className='btn-admitcard' onClick={downloadAdmitCard}>Download Admit Card</button>
            {/* <button className='btn-admitcard' >  <LG_Cont /></button> */}

          </center>
        </div>

      }


    </div>
  );
};

export default AdmitCard;